var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriceTag = function SvgPriceTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3 55.2c-.9 0-1.8-.4-2.5-1l-12-12c-.7-.7-1-1.6-1-2.5s.4-1.8 1-2.5L33 17c1.1-1.1 3.2-2 4.9-2h10.6c1.9 0 3.5 1.6 3.5 3.5v10.6c0 1.6-.9 3.7-2 4.9L29.8 54.2c-.6.6-1.5 1-2.5 1zm10.6-37.9c-1 0-2.5.6-3.2 1.3L14.5 38.8c-.2.2-.3.5-.3.8s.1.6.3.8l12 12c.2.2.5.3.8.3.3 0 .6-.1.8-.3l20.2-20.2c.7-.7 1.3-2.2 1.3-3.2V18.5c0-.7-.5-1.2-1.2-1.2H37.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 26.7c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.5 3.5-3.5 3.5zm0-4.7c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2 1.2-.5 1.2-1.2-.5-1.2-1.2-1.2z"
  })));
};
export default SvgPriceTag;